import { createFileRoute } from "@tanstack/react-router";

import { ComplianceDefinitionHistoryPage } from "@/components/compliance/ComplianceDefinitionHistoryPage";
import { FeatureGate } from "@/components/shared/FeatureGate";
import { FEATURES } from "@/lib/features";

export const Route = createFileRoute(
  "/_authenticated/compliance/definition/$definitionId",
)({
  component: ComplianceDefinitionDetailPage,
});

function ComplianceDefinitionDetailPage() {
  const { definitionId } = Route.useParams();

  return (
    <FeatureGate
      feature={FEATURES.COMPLIANCE_TASKS}
      featureName="Compliance tasks"
    >
      <ComplianceDefinitionHistoryPage definitionId={definitionId} />
    </FeatureGate>
  );
}
